import SearchKeyHighliter from "@/src/components/seachkeyHighlighter";
import { uid } from "@/src/utils/utils";

export default function SnomedSynonymHighliter({
  searchKey,
  name,
  synonyms,
}: {
  searchKey: string;
  name: string;
  synonyms: string;
}) {
  function hasHighlightedPart(str: string) {
    const strParts = str
      .toLowerCase()
      .split(new RegExp(`(${escapeSearchKey(searchKey)})`, "gi"));
    return strParts.some(
      (part) => part.toLowerCase() === searchKey.toLowerCase()
    );
  }

  function escapeSearchKey(searchKey: string) {
    return searchKey.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
  }

  if (hasHighlightedPart(name)) return null;

  const synonymsList = synonyms.split(" , ");

  for (const synonym of synonymsList) {
    if (hasHighlightedPart(synonym)) {
      return (
        <span key={uid()} className="gray">
          <SearchKeyHighliter searchKey={searchKey}>
            {synonym}
          </SearchKeyHighliter>
        </span>
      );
    }
  }
  return null;
}
